export default "__VITE_ASSET__Yqi0Vy9n__"